import CreateNewAccount from "@/components/users/CreateNewAccount"
import UserLogin from "@/components/users/UserLogin"
import { useState } from "react"
import { Button, Modal, Box, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import useIsMobile from "@/hooks/useIsMobile"

const LoginModal = () => {
  const isMobile = useIsMobile()
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [activeTab, setActiveTab] = useState(1)

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleOpen}
        sx={
          isMobile
            ? {
                minWidth: "32px",
                minHeight: "35px",
                maxWidth: "35px",
                maxHeight: "35px",
                fontSize: "12px",
              }
            : {}
        }
      >
        Sign up
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            backgroundColor: "white",
            position: "absolute" as const,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            borderRadius: "8px",
            minWidth: "500px",
            overflow: "hidden",
          }}
        >
          <header
            style={{
              display: "flex",
              backgroundColor: "#FFFFFF",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "50px",
            }}
          >
            <Button
              style={{
                textAlign: "left",
                height: "100%",
                display: "flex",
                width: "100%",
                backgroundColor: activeTab !== 2 ? "#FFFFFF" : "#F0F2F5",
              }}
              onClick={() => setActiveTab(1)}
            >
              <Typography>Login</Typography>
            </Button>
            <Button
              style={{
                width: "100%",
                textAlign: "left",
                height: "100%",
                backgroundColor: activeTab !== 1 ? "#FFFFFF" : "#F0F2F5",
              }}
              onClick={() => setActiveTab(2)}
            >
              <Typography>Create New Account</Typography>
            </Button>
            <div
              style={{
                // padding: ".5rem",
                // background: "#F0F2F5",
                display: "flex",
                alignItems: "center",
                backgroundColor: activeTab !== 1 ? "#FFFFFF" : "#F0F2F5",
                // width: "50px",
                height: "100%",
              }}
            >
              <Button onClick={handleClose}>
                <CloseIcon />
              </Button>
            </div>
          </header>
          <Box sx={{ padding: "2rem" }}>
            {activeTab === 1 ? <UserLogin /> : <CreateNewAccount />}
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default LoginModal
